import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';

@Injectable({
  providedIn: 'root'
})
export class PatientAccessoryAssignmentService {

  constructor(private http: HttpClient, private authService: AuthService, private appProfile: AppProfile) {}

  saveAccessory(accessoryData: any, serialNumber: string, patientId: string): Observable<any> {
    const payload = {
      resourceType: "DeviceRequest",
      requester: {
        reference: "Practitioner/example",
        display: "Dr. Update Adam Careful"
      },
      occurrenceDateTime: accessoryData.assignmentDate,
      text: {
        id: "098876545343434111",
        status: "additional",
        div: "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p><b>Generated Narrative with Details</b></p><p><b>id</b>: example</p><p><b>status</b>: completed</p><p><b>intent</b>: original-order</p><p><b>code</b>: <a>Device/example</a></p><p><b>subject</b>: <a>Patient/example</a></p></div>"
      },
      performer: {
        id: "98787653655665151413",
        display: "Nurse Rossignol",
        reference: "performer"
      },
      meta: {
        versionId: "1",
        lastUpdated: new Date().toISOString(),
        profile: [
          "https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmDeviceRequest"
        ]
      },
      "intent": "original-order",
      codeReference: {
        identifier: {
          value: serialNumber,
          system: "http://www.philips.com/ampm"
        }
      },
      subject: {
        reference: "Patient/example",
        identifier: {
          system: "http://www.philips.com/ampm",
          value: patientId
        }
      },
      extension: [
        {
          url: "https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmPrimaryDeviceExtension",
          valueBoolean: true
        }
      ],
      authoredOn: accessoryData.assignmentDate
    };

    const url = this.appProfile.ampmUs+'/ems/fhir/'+this.appProfile.org+'/DeviceRequest';

    const headers = new HttpHeaders({
      'X-tenant-Id': this.appProfile.tenant,
      'api-version': '1.0.0',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.authService.accessToken}`,
    });

    return this.http.post(url, payload, { headers });
  } 
}
